"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.getGqlData = getGqlData;
exports.fetchGql = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _apolloFetch = require("apollo-fetch");

var fetchGql = (0, _apolloFetch.createApolloFetch)({
  uri: "http://localhost:5000/graphql"
});
exports.fetchGql = fetchGql;

function getGqlData(_x) {
  return _getGqlData.apply(this, arguments);
}

function _getGqlData() {
  _getGqlData = (0, _asyncToGenerator2.default)(
  /*#__PURE__*/
  _regenerator.default.mark(function _callee(request) {
    var response;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return fetchGql(request);

          case 2:
            response = _context.sent;

            if (!response.errors) {
              _context.next = 7;
              break;
            }

            throw response.errors;

          case 7:
            return _context.abrupt("return", response.data);

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getGqlData.apply(this, arguments);
}